import { createAsyncThunk } from "@reduxjs/toolkit";
import { types } from "@vilocnv/allsetra-core";
import { RootState } from "app/store";
import { ObjectIconUpdatedEventDto } from "domain/objects/entities/dtos/object-icon-updated-event.dto";
import { mapIconUpdatedEventToObject } from "domain/objects/entities/mappers/map-object-icon-updated-event-to-object.mapper";

const onObjectIconUpdatedEventAction = createAsyncThunk<
  types.IObject | undefined,
  {
    objectIconUpdatedEventData: ObjectIconUpdatedEventDto | undefined;
  },
  { state: RootState }
>("objects/v2/onObjectIconUpdatedEventAction", async (payload, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const { objectIconUpdatedEventData } = payload;

    if (!objectIconUpdatedEventData) {
      return;
    }

    const object = state.rootReducer.objectsStore.objects.find(
      (obj) => obj.uniqueId === objectIconUpdatedEventData?.uniqueId
    );

    const newObject = mapIconUpdatedEventToObject(
      objectIconUpdatedEventData,
      object
    );

    return newObject;
  } catch (e: any) {
    throw new Error(e);
  }
});

export default onObjectIconUpdatedEventAction;
